import React, { Component } from 'react';
import Modal from './Modal.js';
import './Modal.css';

class NewPatientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPatient: {
                firstName: '',
                lastName: '',
                nationalId: '',
                phone: '',
                birthDate: '',
                email: '',
                bloodType: '',
                chronicDisease: '',
                notes: ''
            }
        };
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            newPatient: {
                ...prevState.newPatient,
                [name]: value
            }
        }));
    };

    handleSave = () => {
        this.props.onSave(this.state.newPatient);
        // Formu temizle
        this.setState({
            newPatient: { firstName: '', lastName: '', nationalId: '', phone: '', birthDate: '', email: '', bloodType: '', chronicDisease: '', notes: '' }
        });
    };

    render() {
        const { isOpen, onClose } = this.props;
        const { newPatient } = this.state;

        if (!isOpen) return null;

        return (
            <Modal title="Add New Patient" onClose={onClose}>
                <div className="modal-body">
                    {/* OCR butonu istenirse buraya eklenebilir */}
                    {/* <button className="import-data-btn"><FileUp size={18}/> Scan ID Card</button> */}
                    <div className="form-grid">
                        <div className="form-group">
                            <label>First Name</label>
                            <input name="firstName" value={newPatient.firstName} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Last Name</label>
                            <input name="lastName" value={newPatient.lastName} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>National ID</label>
                            <input name="nationalId" value={newPatient.nationalId} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Phone</label>
                            <input name="phone" value={newPatient.phone} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Date of Birth</label>
                            <input type="date" name="birthDate" value={newPatient.birthDate} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" name="email" value={newPatient.email} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Blood Type</label>
                            <input name="bloodType" value={newPatient.bloodType} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group">
                            <label>Chronic Disease(s)</label>
                            <input name="chronicDisease" value={newPatient.chronicDisease} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group full-width">
                            <label>Notes</label>
                            <textarea name="notes" value={newPatient.notes} onChange={this.handleInputChange}></textarea>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="save-btn" onClick={this.handleSave}>Save Patient</button>
                </div>
            </Modal>
        );
    }
}

export default NewPatientModal;
